export default "__VITE_ASSET__DGRa$imW__"